export default function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);
  return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/core/~/dom-helpers/esm/hasClass.js
// module id = 1667
// module chunks = 121